import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import Trans from 'next-translate/Trans'
import { Layout } from 'components/Layout'
import { Link } from 'components/Link'
import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { VerticalSeparator } from 'components/VerticalSeparator'
import { CollapsibleMenu } from 'features/components/CollapsibleMenu'
import { PrivacyPolicyType } from 'features/PrivacyPolicy/PrivacyPolicy'
import { CollapsibleContentSection } from '../PrivacyPolicy/components/CollapsibleContentSection'
import {
  TermsAndConditionsRoot,
  Introduction,
  Content,
  Wrapper,
  CollapsibleContentWrapper,
  Contact,
} from './TermsAndConditions.styles'

type TermsAndConditionsOwnProps = ComponentProps<typeof TermsAndConditionsRoot>
export type TermsAndConditionsProps = TermsAndConditionsOwnProps & {}

const TERMS_AND_CONDITIONS: PrivacyPolicyType[] = [
  {
    title: 'terms-and-conditions:changes.title',
    paragraphs1: [
      'terms-and-conditions:changes.description-1',
      'terms-and-conditions:changes.description-2',
      'terms-and-conditions:changes.description-3',
    ],
  },
  {
    title: 'terms-and-conditions:availability.title',
    paragraphs1: ['terms-and-conditions:availability.description-1'],
  },
  {
    title: 'terms-and-conditions:termination.title',
    paragraphs1: [
      'terms-and-conditions:termination.description-1',
      'terms-and-conditions:termination.description-2',
      'terms-and-conditions:termination.description-3',
    ],
  },
  {
    title: 'terms-and-conditions:conduct.title',
    paragraphs1: [
      'terms-and-conditions:conduct.description-1',
      'terms-and-conditions:conduct.description-2',
    ],
    bulletPoints1: [
      'terms-and-conditions:conduct.bullet-1',
      'terms-and-conditions:conduct.bullet-2',
      'terms-and-conditions:conduct.bullet-3',
      'terms-and-conditions:conduct.bullet-4',
    ],
    paragraphs2: [
      'terms-and-conditions:conduct.description-3',
      'terms-and-conditions:conduct.description-4',
    ],
  },
  {
    title: 'terms-and-conditions:accounts.title',
    paragraphs1: ['terms-and-conditions:accounts.description-1'],
    subsections: [
      {
        title: 'terms-and-conditions:eligibility.title',
        paragraphs1: ['terms-and-conditions:eligibility.description-1'],
      },
      {
        title: 'terms-and-conditions:eligibility.confidentiality.title',
        paragraphs1: ['terms-and-conditions:eligibility.confidentiality.description-1'],
        bulletPoints1: [
          'terms-and-conditions:eligibility.confidentiality.bullet-1',
          'terms-and-conditions:eligibility.confidentiality.bullet-2',
          'terms-and-conditions:eligibility.confidentiality.bullet-3',
          'terms-and-conditions:eligibility.confidentiality.bullet-4',
        ],
      },
      {
        title: 'terms-and-conditions:eligibility.communication.title',
        paragraphs1: [
          'terms-and-conditions:eligibility.communication.description-1',
          'terms-and-conditions:eligibility.communication.description-2',
        ],
      },
      {
        title: 'terms-and-conditions:eligibility.optional.title',
        paragraphs1: [
          'terms-and-conditions:eligibility.optional.description-1',
          'terms-and-conditions:eligibility.optional.description-2',
        ],
      },
    ],
  },
  {
    title: 'terms-and-conditions:content.title',
    subsections: [
      {
        title: 'terms-and-conditions:content.content.title',
        paragraphs1: [
          'terms-and-conditions:content.content.description-1',
          'terms-and-conditions:content.content.description-2',
          'terms-and-conditions:content.content.description-3',
          'terms-and-conditions:content.content.description-4',
        ],
      },
      {
        title: 'terms-and-conditions:content.material.title',
        paragraphs1: [
          'terms-and-conditions:content.material.description-1',
          'terms-and-conditions:content.material.description-2',
          'terms-and-conditions:content.material.description-3',
          'terms-and-conditions:content.material.description-4',
          'terms-and-conditions:content.material.description-5',
          'terms-and-conditions:content.material.description-6',
          'terms-and-conditions:content.material.description-7',
        ],
      },
    ],
  },
  {
    title: 'terms-and-conditions:products.title',
    paragraphs1: ['terms-and-conditions:products.description-1'],
    subsections: [
      {
        title: 'terms-and-conditions:products.accuracy.title',
        paragraphs1: [
          'terms-and-conditions:products.accuracy.description-1',
          'terms-and-conditions:products.accuracy.description-2',
          'terms-and-conditions:products.accuracy.description-3',
        ],
      },
      {
        title: 'terms-and-conditions:products.usage.title',
        paragraphs1: [
          'terms-and-conditions:products.usage.description-1',
          'terms-and-conditions:products.usage.description-2',
        ],
      },
      {
        title: 'terms-and-conditions:products.dry-ice.title',
        paragraphs1: ['terms-and-conditions:products.dry-ice.description-1'],
      },
      {
        title: 'terms-and-conditions:products.health.title',
        paragraphs1: [
          'terms-and-conditions:products.health.description-1',
          'terms-and-conditions:products.health.description-2',
        ],
      },
      {
        title: 'terms-and-conditions:products.amounts.title',
        paragraphs1: [
          'terms-and-conditions:products.amounts.description-1',
          'terms-and-conditions:products.amounts.description-2',
        ],
      },
    ],
  },
  {
    title: 'terms-and-conditions:transactions.title',
    subsections: [
      {
        title: 'terms-and-conditions:transactions.amounts.title',
        paragraphs1: ['terms-and-conditions:transactions.amounts.description-1'],
      },
      {
        title: 'terms-and-conditions:transactions.prices.title',
        paragraphs1: [
          'terms-and-conditions:transactions.prices.description-1',
          'terms-and-conditions:transactions.prices.description-2',
          'terms-and-conditions:transactions.prices.description-3',
          'terms-and-conditions:transactions.prices.description-4',
        ],
      },
      {
        title: 'terms-and-conditions:transactions.promotions.title',
        paragraphs1: ['terms-and-conditions:transactions.promotions.description-1'],
        bulletPoints1: [
          'terms-and-conditions:transactions.promotions.bullet-1',
          'terms-and-conditions:transactions.promotions.bullet-2',
          'terms-and-conditions:transactions.promotions.bullet-3',
          'terms-and-conditions:transactions.promotions.bullet-4',
          'terms-and-conditions:transactions.promotions.bullet-5',
          'terms-and-conditions:transactions.promotions.bullet-6',
          'terms-and-conditions:transactions.promotions.bullet-7',
          'terms-and-conditions:transactions.promotions.bullet-8',
          'terms-and-conditions:transactions.promotions.bullet-9',
        ],
      },
      {
        title: 'terms-and-conditions:transactions.credits.title',
        paragraphs1: [
          'terms-and-conditions:transactions.credits.description-1',
          'terms-and-conditions:transactions.credits.description-2',
        ],
      },
      {
        title: 'terms-and-conditions:transactions.one-time.title',
        paragraphs1: ['terms-and-conditions:transactions.one-time.description-1'],
      },
      {
        title: 'terms-and-conditions:transactions.subscriptions.title',
        paragraphs1: [
          'terms-and-conditions:transactions.subscriptions.description-1',
          'terms-and-conditions:transactions.subscriptions.description-2',
          'terms-and-conditions:transactions.subscriptions.description-3',
        ],
      },
      {
        title: 'terms-and-conditions:transactions.trials.title',
        paragraphs1: [
          'terms-and-conditions:transactions.trials.description-1',
          'terms-and-conditions:transactions.trials.description-2',
        ],
      },
    ],
  },
  {
    title: 'terms-and-conditions:shipping.title',
    paragraphs1: [
      'terms-and-conditions:shipping.description-1',
      'terms-and-conditions:shipping.description-2',
      'terms-and-conditions:shipping.description-3',
      'terms-and-conditions:shipping.description-4',
      'terms-and-conditions:shipping.description-5',
      'terms-and-conditions:shipping.description-6',
    ],
  },
  {
    title: 'terms-and-conditions:returns.title',
    paragraphs1: ['terms-and-conditions:returns.description-1'],
  },
  {
    title: 'terms-and-conditions:general.title',
    link: 'mailto:hello@wefeedraw.com',
    subsections: [
      {
        title: 'terms-and-conditions:general.privacy.title',
        paragraphs1: ['terms-and-conditions:general.privacy.description-1'],
      },
      {
        title: 'terms-and-conditions:general.access.title',
        paragraphs1: ['terms-and-conditions:general.access.description-1'],
      },
      {
        title: 'terms-and-conditions:general.indemnification.title',
        paragraphs1: ['terms-and-conditions:general.indemnification.description-1'],
      },
      {
        title: 'terms-and-conditions:general.severability.title',
        paragraphs1: ['terms-and-conditions:general.severability.description-1'],
      },
      {
        title: 'terms-and-conditions:general.disclaimer.title',
        paragraphs1: [
          'terms-and-conditions:general.disclaimer.description-1',
          'terms-and-conditions:general.disclaimer.description-2',
          'terms-and-conditions:general.disclaimer.description-3',
          'terms-and-conditions:general.disclaimer.description-4',
        ],
      },
      {
        title: 'terms-and-conditions:general.copyright.title',
        paragraphs1: [
          'terms-and-conditions:general.copyright.description-1',
          'terms-and-conditions:general.copyright.description-2',
        ],
        numberedItems1: [
          'terms-and-conditions:general.copyright.number-1',
          'terms-and-conditions:general.copyright.number-2',
          'terms-and-conditions:general.copyright.number-3',
          'terms-and-conditions:general.copyright.number-4',
          'terms-and-conditions:general.copyright.number-5',
          'terms-and-conditions:general.copyright.number-6',
        ],
      },
      {
        title: 'terms-and-conditions:general.arbitration.title',
        paragraphs1: [
          'terms-and-conditions:general.arbitration.description-1',
          'terms-and-conditions:general.arbitration.description-2',
        ],
        bulletPoints1: [
          'terms-and-conditions:general.arbitration.bullet-1',
          'terms-and-conditions:general.arbitration.bullet-2',
        ],
        paragraphs2: ['terms-and-conditions:general.arbitration.description-3'],
      },
    ],
  },
]

export const TermsAndConditions = (_props: TermsAndConditionsProps) => {
  const { t } = useTranslation()

  const header = <Header />

  return (
    <TermsAndConditionsRoot>
      <Layout header={header} hideCTA>
        <Content>
          <Wrapper>
            <Stack direction="column" gap={{ '@initial': '4', '@bp2': '8' }}>
              <Stack direction="column" gap={{ '@initial': '3', '@bp2': '7' }}>
                <Stack direction="column" gap={{ '@initial': '2', '@bp2': '3' }}>
                  <Stack direction="column">
                    <Text
                      size={{ '@initial': 'h4', '@bp2': 'h3' }}
                      as="h1"
                      weight="bold"
                      color="accent-black"
                    >
                      {t('terms-and-conditions:title')}
                    </Text>
                    <Text size="small" color="accent-black">
                      {t('terms-and-conditions:subtitle')}
                    </Text>
                  </Stack>
                  <Introduction>
                    <VerticalSeparator color="accent-black" />
                    <Stack direction="column" gap="3">
                      <Text color="accent-black">
                        <Trans
                          i18nKey={'terms-and-conditions:description-1'}
                          components={[<Link key="0" href="/" />]}
                        />
                      </Text>
                      <Text color="accent-black">{t('terms-and-conditions:description-2')}</Text>
                    </Stack>
                  </Introduction>
                </Stack>

                <Stack as="ol" direction="column">
                  {TERMS_AND_CONDITIONS.map(
                    (
                      {
                        title,
                        paragraphs1,
                        bulletPoints1,
                        paragraphs2,
                        bulletPoints2,
                        link,
                        subsections,
                      },
                      i
                    ) => {
                      return (
                        <Stack as="li" direction="column" key={i}>
                          <CollapsibleMenu
                            key={i}
                            label={`${i + 1}.  ${t(title)}`}
                            hasMaxWidth={false}
                          >
                            <CollapsibleContentWrapper>
                              <Stack direction="column" gap="3">
                                <CollapsibleContentSection
                                  paragraphsAndLists={[
                                    {
                                      paragraphs: paragraphs1,
                                      lists: bulletPoints1,
                                      link: link,
                                    },
                                    {
                                      paragraphs: paragraphs2,
                                      lists: bulletPoints2,
                                      link: link,
                                    },
                                  ]}
                                />
                                {subsections &&
                                  subsections.map(
                                    (
                                      {
                                        title,
                                        paragraphs1,
                                        bulletPoints1,
                                        numberedItems1,
                                        paragraphs2,
                                      },
                                      j
                                    ) => {
                                      return (
                                        <Stack direction="column" key={j} gap="3">
                                          <CollapsibleContentSection
                                            number={`${i + 1}.${j + 1}`}
                                            title={t(title)}
                                            paragraphsAndLists={[
                                              {
                                                paragraphs: paragraphs1,
                                                lists: bulletPoints1,
                                                orderedLists: numberedItems1,
                                                link: link,
                                              },
                                              {
                                                paragraphs: paragraphs2,
                                                lists: bulletPoints2,
                                                link: link,
                                              },
                                            ]}
                                          />
                                        </Stack>
                                      )
                                    }
                                  )}
                              </Stack>
                            </CollapsibleContentWrapper>
                          </CollapsibleMenu>
                        </Stack>
                      )
                    }
                  )}
                </Stack>
                <Contact justifyContent="center">
                  <Text size="headline" weight="bold" color="accent-black" align="center">
                    <Trans
                      i18nKey={'terms-and-conditions:contact'}
                      components={[<Link key="0" href="mailto:hello@wefeedraw.com" />]}
                    />
                  </Text>
                </Contact>
              </Stack>
            </Stack>
          </Wrapper>
        </Content>
        <Footer />
      </Layout>
    </TermsAndConditionsRoot>
  )
}

TermsAndConditions.displayName = 'TermsAndConditions'
